module.exports = __webpack_public_path__ + "static/media/TransportPayWallet.c2a6f177.svg";